import {MenuItemProps} from '@dms/api/shared';

export function insertMenuItemsAfter(
  items: MenuItemProps[],
  afterItemId: string,
  itemsToInsert: MenuItemProps[]
): MenuItemProps[] {
  const targetIndex = items.findIndex((item) => item.id === afterItemId);

  if (targetIndex === -1) {
    return [...items, ...itemsToInsert];
  }

  return [...items.slice(0, targetIndex + 1), ...itemsToInsert, ...items.slice(targetIndex + 1)];
}
